<template>
  <div class="grid grid-cols-1">
    <app-document-status-button
      class="status-btn border-4 border-blue rounded-full mt-1 mb-1 px-1"
      :class="requestIsMine ? 'bg-white' : 'bg-blue'"
      @click="changeDocumentActivities('request', documentId, requestStatus)"
      :status="requestStatus"
      :isMine="requestIsMine"
    >
      <template v-slot:buttonText>
        <span
          class="text-lg font-bold"
          :class="requestIsMine ? 'text-blue' : 'text-white'"
          >①申</span
        >
        <span
          class="text-sm font-bold"
          :class="requestIsMine ? 'text-blue' : 'text-white'"
          >請書</span
        >
      </template>
    </app-document-status-button>
    <app-document-status-button
      class="status-btn border-4 border-blue rounded-full mt-1 mb-1 px-1"
      :class="resultIsMine ? 'bg-white' : 'bg-blue'"
      @click="changeDocumentActivities('result', documentId, resultStatus)"
      :status="resultStatus"
      :isMine="resultIsMine"
    >
      <template v-slot:buttonText>
        <span
          class="text-lg font-bold"
          :class="resultIsMine ? 'text-blue' : 'text-white'"
          >②報</span
        >
        <span
          class="text-sm font-bold"
          :class="resultIsMine ? 'text-blue' : 'text-white'"
          >告書</span
        >
      </template>
    </app-document-status-button>
    <app-document-status-button
      class="status-btn border-4 border-blue rounded-full mt-1 mb-1 px-1"
      :class="memoryIsMine ? 'bg-white' : 'bg-blue'"
      @click="changeDocumentActivities('memory', documentId, memoryStatus)"
      :status="memoryStatus"
      :isMine="memoryIsMine"
    >
      <template v-slot:buttonText>
        <span
          class="text-lg font-bold"
          :class="memoryIsMine ? 'text-blue' : 'text-white'"
          >③記</span
        >
        <span
          class="text-sm font-bold"
          :class="memoryIsMine ? 'text-blue' : 'text-white'"
          >録簿</span
        >
      </template>
    </app-document-status-button>
  </div>
</template>

<script>
import AppDocumentStatusButton from '@/components/ui/AppDocumentStatusButton'

import { usePoliticalActionDialog } from '@/services/politicalAction/usePoliticalActionDialog'

export default {
  name: 'AppDocumentStatusIndicator',

  components: {
    AppDocumentStatusButton,
  },

  props: {
    requestStatus: {
      type: Number,
      default: null,
    },
    resultStatus: {
      type: Number,
      default: null,
    },
    memoryStatus: {
      type: Number,
      default: null,
    },
    documentId: {
      type: Number,
      required: true,
    },
    requestIsMine: {
      type: Boolean,
      default: false,
    },
    resultIsMine: {
      type: Boolean,
      default: false,
    },
    memoryIsMine: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    return { ...usePoliticalActionDialog() }
  },
}
</script>
